import gql from 'graphql-tag';

export const GET_PARTNER_PROFILE = gql`
  query GetPartnerProfile($id: ID!) {
    partner(id: $id) {
      id: partnerProfileId
      availableToPro
    }
  }
`;
